import React from "react";
function Enquire() {
    return (
        <>
            <section className=" inner-banner-sec enquire_banner">
                <div className="container-fluid add-padding-2">
                    <div className="inner-bg-img">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 align-self-center">
                                <div className="banner_text">
                                    <h1>
                                        <span>Enquire Now</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="work-together bg-effect">
                <div className="container">
                    <div className="row">
                        <form className="order-form">
                            <div className="row mb-4">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="section-heading">
                                        <h3 />
                                        <p />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
                                    <div className="input-group">
                                        <input type="text" className="form-control" placeholder="FIRST NAME" />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
                                    <div className="input-group">
                                        <input type="text" className="form-control" placeholder="LAST NAME" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-4">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
                                    <div className="input-group">
                                        <input type="email" className="form-control" placeholder="EMAIL" />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
                                    <div className="input-group">
                                        <input type="email" className="form-control" placeholder="YOUR EMAIL ADDRESS" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-4">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="input-group agb">
                                        <select name="package" className="form-select">
                                            <option value={0}>Company / Organization</option>
                                            <option value={1}>Luxury Kitchen &amp; Bathroom Design</option>
                                            <option value={2}>Lighting &amp; Outdoor Aesthetics</option>
                                            <option value={3}>Architect &amp; Designer Collaboration
                                            </option>
                                        </select>
                                        <i className="fa-solid fa-caret-down" aria-hidden="true" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="input-group">
                                        <textarea name="project-details" rows={8} placeholder="MESSAGE" className="form-control" defaultValue={""} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="submit-btn">
                                        <button type="submit" className="theme-btn-1"><span>submit now</span></button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>



        </>
    );
}

export default Enquire;
